<template>
  <div>
    <div :class="['op--modal-container', {hide: !show}]" @click="close">
      <div class="op--modal">
        <div class="op--modal-content">
          <div class="service-selection small-margin-v-s" @click.stop>
            <div class="title">{{ $t('rsvpEdit.chooseService') }}</div>
            <div v-for="(service, index) in services" :key="index"
              :class="['service--item d-flex', {disabled: !isAvailable(service) || (availabilityInfo(service).enabled && availabilityInfo(service).eligible === 0) || service.unavailableTime}]"
              @click="selectService(service)">
              <img :src="getImage(service)" />
              <div class="service-info">
                <div class="availability-error"
                  v-if="availabilityInfo(service).enabled && availabilityInfo(service).eligible === 0">
                  {{ availabilityInfo(service).suggestedLabel }}
                  <span>{{ availabilityInfo(service).suggestedTime }}</span>
                </div>
                <div class="name">{{ lyftRename(service.brandedName) }}</div>
                <div class="price" v-if="!service.unavailableTime">{{ getPrice(service) }}</div>
                <div class="disabled-date" v-if="service.unavailableTime">Not available on the selected date</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div :class="['op--modal-container', {hide: !showOptin}]" v-if="showOptin">
      <div class="op--modal">
        <div class="op--modal-content">
          <div class="optin-box">
            <div class="availability" v-if="isAirportPickup">
              {{ $t('rsvpEdit.availableOnlyFrom') }}
              <b>{{rsvp.sharedAllowedTime.start}} - {{rsvp.sharedAllowedTime.end}}</b>
            </div>
            <h3 class="margin-t-z margin-b-xs">
              {{ $t('rsvpEdit.saveBySharing', {percent: services[edited.serviceCode].optinPercent}) }}
            </h3>
            <div class="opt-copy">
              {{ $t('rsvpEdit.ifWeFind') }}
              <b>${{optinRefundPrice().toFixed(2)}}</b>
              {{ $t('rsvpEdit.atTheTime') }}
              {{ $t('rsvpEdit.doYouWant') }}
            </div>
            
            <a class="op-btn btn-lg btn-block btn-success" href="javascript:;" @click="closeOptin(true)">{{ $t('rsvpEdit.yesIWantToShare') }}</a>
            <a class="op-btn btn-lg btn-block" href="javascript:;" @click="closeOptin(false)">{{ $t('rsvpEdit.noThanks') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import ApiQuote from '../../modules/api/edit-quote'
export default {
  name: 'service-selection',
  data () {
    return {
      showOptin: false
    }
  },
  computed: {
    show () { return this.$store.state.rsvpEdit.serviceSelection.show },
    edited () { return this.$store.state.rsvpEdit.editedRsvp },
    services () { return this.$store.state.rsvpEdit.serviceSelection.services },
    holiday () { return this.$store.state.rsvpEdit.serviceSelection.holiday },
    charter () { return this.$store.state.rsvpDetails.charter },
    rsvp () { return this.$store.state.reservation },
    isAirportPickup () { return this.edited.pickup.geofenceType === 'airport' },
    sharedService () { return this.rsvp.optin.leg1.shared },
    useFullPrice () { return CONFIG.featureToggle.serviceFullPrice }
  },
  methods: {
    close () {
      this.$store.commit('rsvpEdit/hideServiceSelection')
      let selected = this.edited.serviceCode

      if (selected && this.services[selected].optinAllow && !this.isAirportPickup) {
        this.showOptin = true
      }
    },
    isAvailable (service) {
      let self = this
      let passengers = self.edited.passengers
      let luggage = self.edited.luggage

      // let nowPlusBuffer = moment().add(service.bufferTime, 'minutes')
      // let pickupDate = moment(self.edited.pickupTime, 'MM/DD/YYYY hh:mmA')

      return service.prices.length >= passengers && luggage <= service.maxLuggage // &&
        // (!service.bufferTime || (service.bufferTime && nowPlusBuffer.isBefore(pickupDate)))
    },
    getImage (service) {
      let self = this
      if (service.id <= 5) {
        let code = service.code
        if (code === 'shuttle') { code = 'private' }
        let brandCode = self.$store.state.brandCode
        if (brandCode === null) { brandCode = 'op' }
        return 'https://s3-us-west-2.amazonaws.com/mobile-consumer-app/services/' + brandCode + '/' + code + '_on.png'
      }
      return service.img
    },
    getHolidayPrice (service) {
      if (!CONFIG.useOldQuatation) { return 0 }
      return 0
    },
    getPrice (service) {
      let self = this
      let selectedService = self.$store.state.rsvpEdit.serviceSelection.selectedService
      if (selectedService === null && service.code === self.edited.serviceCode) {
        if (this.useFullPrice) {
          let pymnt = self.edited.payment
          return '$' + parseFloat(pymnt.fare + pymnt.airportFee + pymnt.travelInsurance + self.edited.gasFee).toFixed(2)
        }
        return '$' + self.edited.payment.fare.toFixed(2)
      }
      let passengers = self.$store.state.rsvpEdit.editedRsvp.passengers
      let luggage = self.$store.state.rsvpEdit.editedRsvp.luggage

      if (service.prices.length < passengers || luggage > service.maxLuggage || service.unavailableTime) {
        return self.$t('rsvpEdit.NA')
      }
      let holidayPrice = self.getHolidayPrice(service)
      let price = service.prices[passengers - 1].price
      if (this.useFullPrice) {
        return '$' + parseFloat(service.prices[passengers - 1].price + service.airportFee + service.travelInsurance + service.gasFee).toFixed(2)
      }
      if (holidayPrice > 0) {
        price = service.prices[passengers - 1].original + holidayPrice
      }
      return '$' + price.toFixed(2)
    },
    selectService (service) {
      if (!this.isAvailable(service)) { return }
      this.$store.commit('rsvpEdit/emptyEditedService', service.id)
      this.$store.commit('rsvpEdit/setSelectedService', service)
      ApiQuote.updateSelectedService(this)
      this.$store.commit('reservation/setOptinData', {
        leg: 'leg1',
        fields: {enabled: false}
      })
      this.close()
    },
    availabilityInfo (service) {
      let serviceInfo = service
      let enabled = false
      let eligible = 0
      let suggestedLabel = this.$t('rsvpEdit.NA')
      let suggestedTime = ''
      if (serviceInfo.availabilityInfo) {
        enabled = serviceInfo.availabilityInfo.enabled
        eligible = serviceInfo.availabilityInfo.eligible

        if (serviceInfo.availabilityInfo.suggest.after) {
          suggestedLabel = this.$t('rsvpEdit.availableFrom')
          suggestedTime = moment(serviceInfo.availabilityInfo.suggest.after, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
        } else if (serviceInfo.availabilityInfo.suggest.before) {
          suggestedLabel = this.$t('rsvpEdit.availableUntil')
          suggestedTime = moment(serviceInfo.availabilityInfo.suggest.before, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
        }
      }

      return {
        enabled: enabled,
        eligible: eligible,
        suggestedLabel: suggestedLabel,
        suggestedTime: suggestedTime
      }
    },
    optinPrice () {
      let selected = this.edited.serviceCode
      if (!selected || !Object.keys(this.services).length) return 0

      // services[edited.serviceCode].prices[edited.passengers - 1].price
      let origPrice = this.services[selected].prices[(this.edited.passengers || 1) - 1].price
      let percent = this.services[selected].optinPercent / 100
      percent = parseFloat((1 - percent).toFixed(2))
      return origPrice * percent
    },
    optinRefundPrice () {
      let selected = this.edited.serviceCode
      if (!selected || !Object.keys(this.services).length) return 0

      let origPrice = this.services[selected].prices[(this.edited.passenger || 1) - 1].price
      return parseFloat((origPrice - this.optinPrice()).toFixed(2))
    },
    closeOptin (agree) {
      this.$store.commit('reservation/setOptinData', {
        leg: 'leg1',
        fields: {enabled: agree}
      })
      this.showOptin = false
    },
    lyftRename (x) {
      if (x === 'Lyft') return 'Prime Time Express'
      return x
    }
  },
  watch: {
    show: function (value) {
      if (value) {
        document.getElementById('app').style.overflow = 'hidden'
      } else {
        document.getElementById('app').style.overflow = 'auto'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container{ overflow: auto; }
.service-selection {
  background-color: #fff;
  max-width: 400px;
  margin: 10px auto;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);

  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 15px;
  }
}

.service--item {
  border-top: 1px solid rgba(0,0,0,0.2);
  padding: 10px 0;
  position: relative;
  background-color: #fff;
  transition: all 250ms;
  -webkit-transition: all 250ms;
  cursor: pointer;

  &:hover{
    background-color: #f5f5f5;
    border-left: 0 !important;
    border-right: 0 !important;
    border-bottom: 0 !important;
    border-top: 1px solid rgba(0,0,0,0.2) !important;
  }

  & img {
    // display: block;
    height: 60px;
  }

  & .service-info {
    // position: absolute;
    // top: 20px;
    // left: 80px;
    display: inline-block;
    width: calc(100% - 75px);
    margin-left: 10px;
    vertical-align: top;
  }

  .availability-error{
    font-size: 14px;
    float: right;
    text-align: right;

    span{
      font-weight: 600;
      margin-left: 3px;
      display: block;
    }
  }

  & .name {
    font-size: 16px;
    line-height: 16px;
    color: #777;
    margin-bottom: 5px;
  }

  & .price {
    font-size: 18px;
    line-height: 18px;
    font-weight: 700;
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.6;
  }
}

.optin-box {
  background-color: #fff;
  max-width: 470px;
  margin: 10px auto;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  text-align: center;
  
  h3{
    font-size: 24px!important;
  }
  .btn-success{
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// ServiceSelection.vue?926b0a7c